import { render, staticRenderFns } from "./ContentText.vue?vue&type=template&id=df4d3160&scoped=true&"
import script from "./ContentText.vue?vue&type=script&lang=js&"
export * from "./ContentText.vue?vue&type=script&lang=js&"
import style0 from "./ContentText.vue?vue&type=style&index=0&id=df4d3160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4d3160",
  null
  
)

export default component.exports